<template>
    <results-student
            v-if="resultados.length > 0"
            :carrera="carrera"
            :puntaje="puntaje"
            :total="total"
            :resultados="resultados"
            :aprobado="aprobado"
    />
</template>

<script>
    import ResultsStudent from '@/components/Global/ResultsStudent'

    export default {
        name: 'Resultados',
        components: {
            ResultsStudent
        },
        data: () => ({
            puntaje: '',
            total: '',
            resultados: [],
            carrera: '',
            nombre: '',
            aprobado: ''
        }),
        created() {
            this.getEstudiante()
        },
        methods: {
            getEstudiante() {
                this.$store.dispatch('getEstudiante', localStorage.getItem('id_estudiante'))
                    .then((response) => {
                        let data = response.data
                        this.carrera = data.carrera
                        this.nombre = data.nombre
//                        console.log('resultadp de estudiante:', data)
                        this.$store.dispatch('setModulo', 'RESULTADOS ' + this.nombre)
                        this.$store.dispatch('setNav', 'active')
                        this.getResultado()
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            },
            getResultado() {
                this.$store.dispatch('getResultado', localStorage.getItem('id_estudiante'))
                    .then((response) => {
                        this.resultados = response.data.resultados
                        this.puntaje = response.data.puntaje_obtenido
                        this.total = response.data.total[0]
                        this.aprobado = response.data.aprobado
//                        console.log('resultadp de getResultado:', response)
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            }
        }
    }
</script>
<style scoped>
</style>